'use memo';

import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import ListPageHeader from '@/components/ListPageHeader';
import { ProductLogoMediumSalaryAndWages } from '@/components/Logo';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { salaryAndWagesKeyPrefix } from './-utils/i18n';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: salaryAndWagesKeyPrefix
  });
  useDocumentTitle(t($ => $.pageTitle));
  const matchRoute = useMatchRoute();
  /**
   * 詳細ページは専用ヘッダ（パンくずで一覧へ戻る）を持つため、モジュールの
   * ListPageHeader は出さない。個人の給与明細詳細と給与計算項目詳細が対象。
   */
  const isDetailPage = Boolean(matchRoute({
    to: '/salary-and-wages/reports/$employeeId',
    fuzzy: true
  }) || matchRoute({
    to: '/salary-and-wages/payroll-items/$payrollItemId',
    fuzzy: true
  }));
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <div className="flex h-full min-h-0 min-w-0 flex-col">
      {!isDetailPage ? <ListPageHeader icon={<ProductLogoMediumSalaryAndWages />} title={t($ => $.pageTitle)} tabs={[{
      to: '/salary-and-wages/overview',
      children: t($ => $.tabs.overview),
      activeOptions: {
        exact: true
      }
    }, {
      to: '/salary-and-wages/reports',
      children: t($ => $.tabs.reports),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/salary-and-wages/payroll-items',
      children: t($ => $.tabs.payrollItems),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/salary-and-wages/contract-and-cost',
      children: t($ => $.tabs.contractAndCost),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/salary-and-wages/alerts',
      children: t($ => $.tabs.alerts),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/salary-and-wages/rule-and-policy',
      children: t($ => $.tabs.ruleAndPolicy),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/salary-and-wages/settings',
      children: t($ => $.tabs.settings),
      activeOptions: {
        exact: false
      }
    }]} /> : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>;
}